<div class="card-container">
  <img class="employee-avatar" [src]="employee().photo || '/assets/img/defaultAvatar.png'" [alt]="'avatar_' + employee().name" />
  <div class="text-container">
    <span class="employee-name">{{ employee().name }}</span>
    <span class="employee-position">{{ employee().position }}</span>
  </div>
</div>
